/**
 * Tab-Card Binding
 * Two-way binding between tabs and expandable cards
 * - When a tab is clicked, the corresponding card expands
 * - When a card is clicked, the corresponding tab becomes active AND the card expands
 */

(function () {
  'use strict';

  const DEBUG = false; // Set to false to disable console logs

  function log(...args) {
    if (DEBUG) console.log('[Tab-Card Binding]', ...args);
  }

  // Wait for both DOM and expandable-cards.js to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // Give expandable-cards.js time to initialize
    setTimeout(init, 100);
  }

  function init() {
    log('Initializing tab-card binding...');
    initTabToCardBinding();
    initCardToTabBinding();
    log('Tab-card binding initialized!');
  }

  /**
   * Initialize tab-to-card binding
   * When a tab is clicked, expand the corresponding card
   */
  function initTabToCardBinding() {
    log('Setting up tab-to-card binding...');
    
    // Listen for tab button clicks
    document.addEventListener('click', (e) => {
      const tabButton = e.target.closest('.tab-button');
      if (!tabButton) return;

      // Get the tab ID directly from the button
      const tabId = tabButton.dataset.tabId;
      if (!tabId) {
        log('Tab clicked but no tab_id found:', tabButton);
        return;
      }

      log('Tab clicked with ID:', tabId);

      // Find the corresponding expandable card
      const card = document.querySelector(`.card-item[data-tab-id="${tabId}"]`);
      if (!card) {
        log('No card found with tab_id:', tabId);
        return;
      }

      log('Found matching card, expanding...');

      // Expand the card after a small delay to allow tab switch animation
      setTimeout(() => {
        // Trigger the expand button click to use existing functionality
        const expandBtn = card.querySelector('.expand-btn');
        if (expandBtn && !card.classList.contains('card-expanded')) {
          log('Clicking expand button');
          expandBtn.click();
        } else {
          log('Card already expanded or no expand button found');
        }
      }, 150);
    });
  }

  /**
   * Initialize card-to-tab binding
   * When a card is clicked, activate the corresponding tab
   */
  function initCardToTabBinding() {
    log('Setting up card-to-tab binding...');
    
    // Listen for clicks on expandable cards
    document.addEventListener('click', (e) => {
      // Check if click is on or within a card
      const card = e.target.closest('.card-item');
      if (!card) return;

      // Get the tab ID from the card
      const tabId = card.dataset.tabId;
      if (!tabId) {
        log('Card clicked but no tab_id found:', card);
        return;
      }

      log('Card clicked with ID:', tabId);

      // Find the corresponding tab button
      const tabButton = document.querySelector(`.tab-button[data-tab-id="${tabId}"]`);
      if (!tabButton) {
        log('No tab button found with tab_id:', tabId);
        return;
      }

      // Check if tab is already active
      if (tabButton.classList.contains('active')) {
        log('Tab already active');
        return;
      }

      log('Activating corresponding tab...');

      // Activate the tab
      setTimeout(() => {
        tabButton.click();
      }, 50);
    });
  }

})();
